module.exports = __webpack_public_path__ + "static/pinkstarvelourhamper-3c8b4d73540debefb0bc71dd1e346f41.jpeg";